<div class="no-records">
  <h3>{{ maintitle }}</h3>
  <p>{{ message }}</p>
</div>
